// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1YZHn","approved":"Status_approved__YPxUt","rejected":"Status_rejected__2nsYu","expired":"Status_expired__1uKvB","label":"Status_label__2_9Qt"};